import React, {useEffect, useState} from 'react';
import { Facebook } from 'lucide-react';
import { useDispatch, useSelector } from 'react-redux';
  import { useNavigate } from 'react-router-dom';
  import axios from 'axios';
  import { apiUrl } from '../../config/Config';
  import Swal from 'sweetalert2';

const Facebooklogin = () => {
  let navigate = useNavigate();
  const userdata = useSelector((store) => store.userReducer.userdata);
  const [loginloading, setloginloading] = useState(false);

  console.log('userdata >', userdata);
  
  const handleFBLogin = () => {
    window.FB.login(
      function (response) {
        if (response.authResponse) {
          const accessToken = response.authResponse.accessToken;
          console.log('response.authResponse >>', response.authResponse);
          console.log("Access Token >>", accessToken);
          // if(accessToken) {
          //   storefbtoken(accessToken);
          // }
          
  
          // You can now use this token to call Graph API
        } else {
          Swal.fire({
            title: '',
            text: "User cancelled login or did not authorize.",
            icon: 'error',
            customClass: {
              icon: 'custom-swal-icon' // Apply the custom class
            },
            width: '350px',
            confirmButtonText: 'Ok',
        confirmButtonColor: "rgb(59, 151, 196)",
            customClass: {
                popup: "small-icon-alert",
              },
          });
        }
      },
      // --- CORRECTED SCOPES ---
      { scope: "public_profile,email,pages_show_list,pages_read_engagement,pages_read_user_content,pages_manage_posts,pages_manage_metadata,read_insights, instagram_basic, instagram_content_publish, instagram_manage_insights" }
    );
  }

    useEffect(() => {
            // 1. Load Facebook SDK Script
            const loadFacebookSDK = () => {
              if (document.getElementById("facebook-jssdk")) return;
        
              const script = document.createElement("script");
              script.id = "facebook-jssdk";
              script.src = "https://connect.facebook.net/en_US/all.js";
              script.async = true;
              script.defer = true;
              document.body.appendChild(script);
        
              window.fbAsyncInit = function () {
                window.FB.init({
                  appId: "615894628233072",
                  cookie: true,
                  xfbml: true,
                  version: "v23.0",
                });
        
                console.log("Facebook SDK Initialized");
              };
            };
        
            loadFacebookSDK();
          }, []);

  return (
    <div className="facebook-login-page">
      <div className="login-card">
        
        {/* SVG Illustration */}
        <div className="login-illustration">
          <svg viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="200" height="200" fill="#EDE9FE" />
            <circle cx="50" cy="50" r="30" fill="#8B5CF6" opacity="0.8"/>
            <circle cx="150" cy="80" r="25" fill="#C084FC" opacity="0.7"/>
            <circle cx="80" cy="150" r="35" fill="#A78BFA" opacity="0.9"/>
            <line x1="60" y1="60" x2="140" y2="75" stroke="#9333EA" strokeWidth="4" strokeLinecap="round" opacity="0.6"/>
            <line x1="65" y1="40" x2="75" y2="140" stroke="#9333EA" strokeWidth="4" strokeLinecap="round" opacity="0.6"/>
            <line x1="145" y1="85" x2="85" y2="145" stroke="#9333EA" strokeWidth="4" strokeLinecap="round" opacity="0.6"/>
            <circle cx="30" cy="100" r="8" fill="#C084FC" opacity="0.5"/>
            <circle cx="170" cy="30" r="10" fill="#A78BFA" opacity="0.5"/>
            <circle cx="120" cy="170" r="7" fill="#8B5CF6" opacity="0.5"/>
            <circle cx="10" cy="20" r="5" fill="#C084FC" opacity="0.4"/>
            <circle cx="180" cy="130" r="6" fill="#A78BFA" opacity="0.4"/>
          </svg>
        </div>

        {/* Form Section */}
        <div className="login-form-section">
          <h2 className="login-title">Welcome !</h2>
          <p className="login-subtitle">Sign in to continue your journey.</p>

          <button className="facebook-button" onClick={() => {handleFBLogin()}}>
            <Facebook className="facebook-icon" />
            Sign In with Facebook
          </button>

          <div className="divider">
            <span>Or</span>
          </div>

          <p className="help-text">
            Having trouble? <a href="#">Get help</a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Facebooklogin;
